import React from "react";
import SliderCore from "rc-slider";
import "rc-slider/assets/index.css";
import { dashboardColors, theme } from "../../../themes/Theme";

const Slider = ({ min, max, value, onChange, step, ...props }) => {
	return (
		<>
			<SliderCore
				min={min}
				max={max}
				value={value}
				onChange={onChange}
				step={step}
				{...props}
			/>
			<style>{`
                .rc-slider-rail {
                    background-color: #E7E0E5;
                    height: 6px;
                }

                .rc-slider-track {
                    background-color: ${dashboardColors[theme].primary};
                    height: 6px;
                }

                
                .rc-slider-handle {
                    width: 16px;
                    height: 16px;
                    margin-top: -5px;
                    background-color: ${dashboardColors[theme].primary};
                    border: solid 2px ${dashboardColors[theme].primary};
                    cursor: pointer;
                    opacity: 1;
                    touch-action: pan-x;
                }

                .rc-slider-handle:hover {
                    border-color: ${dashboardColors[theme].primary} !important;
                }

                .rc-slider-handle:active {
                    border-color: ${dashboardColors[theme].primary} !important;
                    box-shadow: 0 0 5px ${dashboardColors[theme].primary} !important;
                    cursor: pointer !important;
                }

                .rc-slider-handle-dragging {
                    border-color: ${dashboardColors[theme].primary} !important;
                    box-shadow: 0px 0px 3px 0px #000 !important;
                }
            `}</style>
		</>
	);
};

export default Slider;
